import React from 'react';
import { StepProps } from '../MultiStepModal';

export default function CertificateTemplateConfirmStep({ data }: StepProps) {
  const schema = (data as any)?.inferredSchema;
  const screens: any[] = Array.isArray(schema?.screens) ? schema.screens : [];
  const lowConfidenceCount = Number((data as any)?.lowConfidenceCount ?? 0);

  const totalFieldCount = (() => {
    let n = 0;
    for (const s of screens) {
      const sections: any[] = Array.isArray(s?.sections) ? s.sections : [];
      for (const sec of sections) {
        const fs: any[] = Array.isArray(sec?.fields) ? sec.fields : [];
        n += fs.length;
      }
    }
    return n;
  })();

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Confirm</h3>
        <p className="step-form-subtitle">Review your template before saving.</p>
      </div>

      <div className="step-form-content">
        <div className="rounded-xl border border-[#E6E6E4] bg-white p-4">
          <div className="text-sm font-semibold text-[#181818]">Template</div>
          <div className="mt-3 grid grid-cols-1 gap-3 text-sm md:grid-cols-2">
            <div>
              <div className="text-xs text-[#686E6C]">Prefix</div>
              <div className="mt-1 font-medium text-[#181818]">{data.certificatePrefix || '—'}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Type</div>
              <div className="mt-1 font-medium text-[#181818]">{data.certificateTypeName || '—'}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Label</div>
              <div className="mt-1 font-medium text-[#181818]">{data.templateLabel || '—'}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Fields</div>
              <div className="mt-1 font-medium text-[#181818]">{totalFieldCount}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Screens</div>
              <div className="mt-1 font-medium text-[#181818]">{screens.length}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Low confidence</div>
              <div className="mt-1 font-medium text-[#181818]">{lowConfidenceCount}</div>
            </div>
          </div>

          {data.templatePreviewUrl ? (
            <div className="mt-4">
              <a
                href={data.templatePreviewUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-ghost"
              >
                Preview PDF
              </a>
            </div>
          ) : null}
        </div>

        <div className="mt-4 rounded-lg border border-[#E6E6E4] bg-[#FAFAF9] p-4 text-xs text-[#686E6C]">
          Clicking “Complete” will save the template to your workspace and make it available for certificate generation.
        </div>
      </div>
    </div>
  );
}
